import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { find } from 'lodash';
import { TranslateService } from '@ngx-translate/core';
import { TelemetryView } from '../_models/telemetryConfig';
import { environment } from '../../../environments/environment';
import { Equipment } from '../_models/equipment';

@Injectable()
export class TelemetryConfigurationService {
  private apiBaseUrl = environment.apiBaseUrl;
  private config$: any;

  constructor(
    private http: HttpClient,
    private translate: TranslateService
  ) {}

  getTelemetryConfiguration(): Observable<any[]> {
    return this.http.get<any>(this.apiBaseUrl + 'api/private/v1/telemetryViewConfig').pipe(
      map((response) => {
        this.config$ = response;
        return response;
      })
    );
  }

  getConfigByProvider(provider: string) {
    const providerConfig = find(this.config$, (c) => c.hasOwnProperty(provider));
    if (providerConfig == undefined) {
      return [] as TelemetryView[];
    }
    const configList = providerConfig[provider];
    return configList as TelemetryView[];
  }

  getParameterConfiguration(currentConfigProviderObject: TelemetryView[], paramKey: string) {
    const param = find(currentConfigProviderObject, (c: any) => c.key == paramKey);
    return param as TelemetryView;
  }

  setConfigurationLocal(provider: string, currentConfigProviderObject: TelemetryView[]) {
    const providerConfig = find(this.config$, (c) => c.hasOwnProperty(provider));
    if (providerConfig != undefined) {
      providerConfig[provider] = currentConfigProviderObject;
    }
    // console.log(this.config$)
  }

  setCustomName(item: TelemetryView, name: string) {
    if (item.customName == true) {
      item.customNameString = name;
    }
    return item;
  }

  getBooleanConfiguration(config: TelemetryView, equip: Equipment) {
    if (
      config.booleanConfigLabel &&
      equip &&
      equip.toolConfiguration &&
      equip.toolConfiguration.toolConfig &&
      equip.toolConfiguration.toolConfig.length > 0
    ) {
      // console.log(config.booleanConfigLabel.split("|"))
      // console.log(equip.toolConfiguration.toolConfig)
      const signalList = [];
      const configPath = config.configPath.split('.');
      equip.toolConfiguration.toolConfig.forEach((tc) => {
        tc[configPath[0]].forEach((s) => {
          signalList.push(s);
        });
      });
      const existSignal = find(signalList, (s) => s[configPath[1]] == config.key);
      if (existSignal) {
        const label = config.booleanConfigLabel.split('|');
        return [existSignal[label[0]], existSignal[label[1]]];
      }
    }

    if (config.booleanLabel) {
      return config.booleanLabel.split('|');
    }

    return ['T', 'F'];
  }

  getBooleanConfigurationTooltip(toolConfiguration, externalResource, signalKey) {
    const equip = new Equipment();
    equip.toolConfiguration = toolConfiguration;
    const configForProvider = find(this.config$, (c) => c.hasOwnProperty(externalResource));
    let config = find(configForProvider[externalResource], (c: any) => c.key == signalKey);
    if (config == null) {
      config = new TelemetryView();
      config.booleanConfigLabel = null;
    }
    return this.getBooleanConfiguration(config, equip);
  }

  getNameByConfig(dataParam, externalResource) {
    const configForProvider = find(this.config$, (c) => c.hasOwnProperty(externalResource));
    if (configForProvider != null) {
      const config = find(configForProvider[externalResource], (c: any) => c.key == dataParam.key);
      if (config && config.customName != true) {
        return this.translate.instant('telemetry_signal_label.' + config.translateKey);
      } else {
        return dataParam.name;
      }
    }
    return this.translate.instant(dataParam.key, {});
  }
}
